export default __webpack_public_path__ + "static/media/Univers-Condensed.a56bd63d.ttf";